export enum ActionComponentType {
  NORMAL = "NORMAL",
  TIMER = "TIMER",
  QC = "QC",
  STOP = "STOP",
  WASH_AND_STAIN = "WASH_AND_STAIN",
  WORK_FILE_DOWNLOAD = "WORK_FILE_DOWNLOAD",
  WORK_FILE_UPLOAD = "WORK_FILE_UPLOAD"
}
